import Vue from "vue";
import Router from "vue-router";
import { getToken } from "@/utils/auth";
import getPageTitle from "@/utils/get-page-title";

const whiteList = ["/login"];

var router = new Router({
    mode: "hash",
    routes: [{
            path: "/",
            name: "home",
            component: () =>
                import ("@/views/home/index"),
            meta: { title: "主页面", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/notice",
            name: "homeNotice",
            component: () =>
                import ("@/views/home/notice"),
            meta: { title: "历史通知", keepAlive: false, isBack: true, backHome: true },
        },

        // 签到
        {
            path: "/sign",
            name: "sign",
            component: () =>
                import ("@/views/signIn/index"),
            meta: { title: "签到", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/sign/list",
            name: "signList",
            component: () =>
                import ("@/views/signIn/list"),
            meta: { title: "历史签到", keepAlive: false, isBack: false, backHome: true },
        },

        // 客户
        {
            path: "/customer",
            name: "customer",
            component: () =>
                import ("@/views/customer/index"),
            meta: { title: "新增客户", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/customer/list",
            name: "customerList",
            component: () =>
                import ("@/views/customer/list"),
            meta: { title: "我的客户", keepAlive: false, isBack: false, backHome: true },
        },
        {
            path: "/customer/publicList",
            name: "customerPublic",
            component: () =>
                import ("@/views/customer/publicList"),
            meta: { title: "公共客户", keepAlive: false, isBack: false, backHome: true },
        },
        {
            path: "/customer/follow",
            name: "customerFollow",
            component: () =>
                import ("@/views/customer/follow"),
            meta: { title: "客户跟进", keepAlive: false, isBack: true },
        },
        {
            path: "/customer/details",
            name: "customerDetails",
            component: () =>
                import ("@/views/customer/details"),
            meta: { title: "客户详情", keepAlive: false, isBack: true },
        },

        {
            path: "/review",
            name: "review",
            component: () =>
                import ("@/views/review/index"),
            meta: { title: "流程审批 ", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/review/add",
            name: "reviewAdd",
            component: () =>
                import ("@/views/review/add"),
            meta: { title: "新的申请", keepAlive: false, isBack: true },
        },
        {
            path: "/review/details",
            name: "reviewDetails",
            component: () =>
                import ("@/views/review/details"),
            meta: { title: "详情", keepAlive: false, isBack: true },
        },
        {
            path: "/review/approval",
            name: "reviewApproval",
            component: () =>
                import ("@/views/review/approval"),
            meta: { title: "流程审批", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/review/list",
            name: "reviewList",
            component: () =>
                import ("@/views/review/list"),
            meta: { title: "流程审批", keepAlive: false, isBack: true, backHome: true },
        },

        {
            path: "/dispatch",
            name: "dispatch",
            component: () =>
                import ("@/views/dispatch/index"),
            meta: { title: "服务派单", keepAlive: true, isBack: true, backHome: true },
        },
        {
            path: "/dispatch/initiate",
            name: "dispatchInitiate",
            component: () =>
                import ("@/views/dispatch/initiate"),
            meta: { title: "服务派单", keepAlive: true, isBack: true, backHome: true },
        },
        {
            path: "/dispatch/carriedOut",
            name: "dispatchCarriedOut",
            component: () =>
                import ("@/views/dispatch/carriedOut"),
            meta: { title: "服务派单", keepAlive: true, isBack: true, backHome: true },
        },
        {
            path: "/dispatch/add",
            name: "dispatchAdd",
            component: () =>
                import ("@/views/dispatch/add"),
            meta: { title: "服务派单", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/dispatch/details",
            name: "dispatchDetails",
            component: () =>
                import ("@/views/dispatch/details/details"),
            meta: { title: "派单详情", keepAlive: false, isBack: true },
        },
        {
            path: "/dispatch/details_distribution",
            name: "dispatchDetailsDistribution",
            component: () =>
                import ("@/views/dispatch/details/details_distribution"),
            meta: { title: "分配详情", keepAlive: false, isBack: true },
        },
        {
            path: "/dispatch/details_carryout",
            name: "dispatchDetailsCarryout",
            component: () =>
                import ("@/views/dispatch/details/details_carryout"),
            meta: { title: "完成派单", keepAlive: false, isBack: true },
        },
        // 生产管理
        {
            path: "/drawing",
            name: "drawing",
            component: () =>
                import ("@/views/drawing/list"),
            meta: { title: "生产列表", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/drawing/details",
            name: "drawingDetails",
            component: () =>
                import ("@/views/drawing/details/details"),
            meta: { title: "生产详情", keepAlive: false, isBack: true },
        },
        {
            path: "/drawing/audit",
            name: "drawingAudit",
            component: () =>
                import ("@/views/drawing/audit"),
            meta: { title: "生产单审核", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/stock",
            name: "stock",
            component: () =>
                import ("@/views/stock/index"),
            meta: { title: "库存查询", keepAlive: false, isBack: true, backHome: true },
        },

        {
            path: "/stock/detial",
            name: "stockDetail",
            component: () =>
                import ("@/views/stock/detail"),
            meta: { title: "库存详情", keepAlive: false, isBack: true },
        },

        {
            path: "/order",
            name: "order",
            component: () =>
                import ("@/views/order/index"),
            meta: { title: "销售订单", keepAlive: false, isBack: true },
        },
        {
            path: "/order/list",
            name: "orderList",
            component: () =>
                import ("@/views/order/list"),
            meta: { title: "销售订单", keepAlive: true, isBack: true, backHome: true },
        },
        {
            path: "/order/details",
            name: "orderDetails",
            component: () =>
                import ("@/views/order/details/details"),
            meta: { title: "销售订单", keepAlive: false, isBack: true },
        },
        {
            path: "/order/productDetails",
            name: "orderProductDetails",
            component: () =>
                import ("@/views/order/details/productDetails"),
            meta: { title: "销售订单", keepAlive: false, isBack: true },
        },
        {
            path: "/order/recordingDetails",
            name: "orderRecordingDetails",
            component: () =>
                import ("@/views/order/details/recordingDetails"),
            meta: { title: "销售订单", keepAlive: false, isBack: true },
        },

        {
            path: "/purchase",
            name: "purchase",
            component: () =>
                import ("@/views/purchase/list"),
            meta: { title: "采购列表", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/purchase/details",
            name: "purchaseDetails",
            component: () =>
                import ("@/views/purchase/details/details"),
            meta: { title: "采购详情", keepAlive: false, isBack: true },
        },
        {
            path: "/purchase/pay",
            name: "purchasePay",
            component: () =>
                import ("@/views/purchase/details/pay"),
            meta: { title: "支付", keepAlive: false, isBack: true },
        },
        {
            path: "/purchase/add",
            name: "purchaseAdd",
            component: () =>
                import ("@/views/purchase/add"),
            meta: { title: "新建采购", keepAlive: false, isBack: true },
        },
        {
            path: "/purchase/audit",
            name: "purchaseAudit",
            component: () =>
                import ("@/views/purchase/audit"),
            meta: { title: "采购详情", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/returnManagement",
            name: "returnManagement",
            component: () =>
                import ("@/views/returnManagement/list"),
            meta: { title: "退货列表", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/returnManagement/details",
            name: "returnManagementDetails",
            component: () =>
                import ("@/views/returnManagement/details/details"),
            meta: { title: "退货详情", keepAlive: false, isBack: true },
        },
        {
            path: "/returnManagement/audit",
            name: "returnManagementAudit",
            component: () =>
                import ("@/views/returnManagement/audit"),
            meta: { title: "退货审核", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/login",
            name: "login",
            component: () =>
                import ("@/views/login/index2"),
            meta: { title: "登录", keepAlive: false, isBack: true, backHome: true },
        },
        {
            path: "/error",
            name: "error",
            component: () =>
                import ("@/views/error/index"),
            meta: { title: "错误", keepAlive: false, isBack: true, backHome: true },
        },
    ],
});

router.beforeEach(async(to, from, next) => {
    // document.title = getPageTitle(to.meta.title)
    document.title = getPageTitle();

    const hasToken = getToken();

    // if (from.path.indexOf('details') != -1) {
    // 	to.meta.keepAlive = true;
    // }

    if (from.name != null && from.name.indexOf("Details") >= 0) {
        to.params.refresh = true;
    }

    if (from.name == null) {
        to.params.refresh = true;
    }

    if (from.params.listRefresh == true) {
        to.params.refresh = true;
    }

    if (hasToken == "undefined" || hasToken == undefined || hasToken == "") {
        if (whiteList.indexOf(to.path) !== -1) {
            next();
        } else if (to.path === "/error") {
            next();
        } else {
            let href = window.location.href;
            let code = href.match(/(\S*)(code==&)/);
            if (code != "" || code != undefined) {
                next({
                    path: "/login",
                    query: {
                        code: code,
                    },
                });
            } else {
                next({ path: "/login" });
            }
        }
    } else {
        next();
    }
});

export default router;

Vue.use(Router);